/** `.heic` / `.heif` 확장자 판정용. `accept` 패턴과 표기를 맞춘다. */
const HEIC_HEIF_EXT_RE = /\.(heic|heif)$/i;

/** 파일명이 `.heic` / `.heif` 로 끝나는지. MIME 는 보지 않는다. */
export function hasHeicExtension(fileName: string): boolean {
  return HEIC_HEIF_EXT_RE.test(fileName);
}

/**
 * `File` 이 HEIC/HEIF 포맷인지 판정한다.
 *
 * 확장자(`.heic`/`.heif`) 또는 MIME 타입(`image/heic`/`image/heif`) 중 하나라도 맞으면 true.
 * iOS 에서 선택된 파일은 MIME 가 비어있는 경우가 있어 확장자도 함께 본다.
 */
export function isHeicFile(file: File): boolean {
  return hasHeicExtension(file.name) || file.type === "image/heic" || file.type === "image/heif";
}

/**
 * 확장자는 HEIC/HEIF 인데 브라우저가 이미지 MIME 를 붙여주지 못한 파일인지.
 *
 * 브라우저는 `File.type` 을 OS 에서 가져온다. macOS 는 UTI 로 항상 `image/heic` 를 주지만,
 * Windows 는 레지스트리(`HKCR\.heic\Content Type`)를 보기 때문에 HEIF Image Extensions 가
 * 설치돼 있지 않으면 빈 문자열이 온다. 이 파일들은 `image/*` 기반 필터에서 조용히 탈락한다.
 * — Windows 에서만 HEIC 업로드가 안 되는 현상의 지표로 쓴다.
 */
export function isHeicWithMissingMime(file: File): boolean {
  return hasHeicExtension(file.name) && !file.type.startsWith("image/");
}
